module.exports = __webpack_public_path__ + "img/beginning-locked.9401bfa0.png";